import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PolicyViolations = ({ violations }) => {
  const getViolationTypeConfig = (type) => {
    switch (type) {
      case 'excessive':
        return {
          icon: 'TrendingUp',
          color: 'text-error',
          bg: 'bg-error/10'
        };
      case 'pattern':
        return {
          icon: 'Activity',
          color: 'text-warning',
          bg: 'bg-warning/10'
        };
      case 'documentation':
        return {
          icon: 'FileText',
          color: 'text-warning',
          bg: 'bg-warning/10'
        };
      default:
        return {
          icon: 'AlertCircle',
          color: 'text-muted-foreground',
          bg: 'bg-muted'
        };
    }
  };

  return (
    <div className="bg-card border border-border rounded-md p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-2">
          <Icon name="ShieldAlert" size={20} color="var(--color-error)" />
          <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground">
            Policy Violations
          </h3>
        </div>
        {violations?.length > 0 && (
          <span className="px-2 py-1 bg-error text-error-foreground rounded-md caption text-xs font-medium">
            {violations?.length}
          </span>
        )}
      </div>
      <div className="space-y-3">
        {violations?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="ShieldCheck" size={48} color="var(--color-success)" className="mx-auto mb-3" />
            <p className="caption text-sm text-muted-foreground">No policy violations detected</p>
          </div>
        ) : (
          violations?.map((violation) => {
            const config = getViolationTypeConfig(violation?.type);
            return (
              <div
                key={violation?.id}
                className="border border-border rounded-md p-3 transition-smooth hover:shadow-sm"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className={`flex items-center justify-center w-8 h-8 ${config?.bg} rounded-md flex-shrink-0`}>
                    <Icon name={config?.icon} size={16} color={config?.color} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-body font-medium text-sm text-foreground mb-1">
                      {violation?.employeeName}
                    </p>
                    <p className="caption text-xs text-muted-foreground mb-2">
                      {violation?.description}
                    </p>
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="caption text-xs text-muted-foreground">
                        Department: {violation?.department}
                      </span>
                      <span className="caption text-xs text-muted-foreground">•</span>
                      <span className="caption text-xs text-muted-foreground">
                        Detected: {violation?.detectedDate}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" iconName="Eye" iconPosition="left">
                    Review
                  </Button>
                  <Button variant="ghost" size="sm" iconName="MessageSquare" iconPosition="left">
                    Contact
                  </Button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default PolicyViolations;